import * as React from 'react';
import { EventGroupType } from '../../Common/Constants/EventGroupType.Constants';
import TelemetryService from '../../Services/Services.Primary/Telemetry/TelemetryService';
import LocalizationService from '../../Services/Services.Secondary/Localization/LocalizationService';
import { Constants } from './Constants';
import InfoView from './InfoView';
import { ServiceHealth, ServiceHealthV2 } from './Models/ServiceHealth';
import { Solution } from './Models/Solution';
import { SupportTopic } from './Models/SupportTopic';
import ServiceHealthStatus from './ServiceHealthStatus';

//Resource files
const resx = LocalizationService.getInstance();
let Constant = Constants.getInstance();
let tracingService = TelemetryService.getInstance();
let ServicesArea_text = 'Services area';
let ServicesAnnouncement_text = 'Service announcement';
let ServiceAvailability_text = resx.getLocalizedResource('ServiceAvailability_text');
let CSPServiceHealthStatus_text = resx.getLocalizedResource('CSPServiceHealthStatus_text');

interface ISolutionsViewProps {
  continue: (supportTopic: SupportTopic) => void;
  issueType: SupportTopic;
  issueTitle: string;
  scopingSolution: Solution | null;
  serviceHealthInfo: ServiceHealth[];
  activeTopicIncident?: ServiceHealthV2;
  solutionBackButton: JSX.Element;
  solutionNextStepDiv: JSX.Element;
  workspaceView: boolean;
}

interface ISolutionsViewState {}

export default class SolutionsView extends React.Component<ISolutionsViewProps, ISolutionsViewState> {
  constructor(props: ISolutionsViewProps) {
    super(props);
  }
  componentDidMount() {
    let eventName = Constant.actionTypes.landOnSolution;
    let topic = this.props.issueType;
    tracingService.traceEvent(
      eventName,
      { supportTopicId: topic.id.toString(), supportTopicName: topic.name },
      EventGroupType.solutions
    );
  }

  private logOnClick = (event: React.FormEvent<EventTarget>) => {
    var element = event.target as any;
    if (element.tagName.toLowerCase() === 'a') {
      let eventName = Constant.actionTypes.solutionClickLink;
      tracingService.traceEvent(eventName, { href: element.href }, EventGroupType.solutions);
    }
  };

  public render() {
    let solutionsView;
    if (this.props.scopingSolution) {
      let tempSolution: Solution = this.props.scopingSolution as Solution;
      let htmlContentString: string = tempSolution.htmlContent ?? '';
      htmlContentString = htmlContentString.split('<a ').join('<a target="_blank" ');
      htmlContentString = htmlContentString
        .split('</a>')
        .join('&nbsp;<span class="win-icon win-icon-OpenInNewWindow"></span></a>');
      htmlContentString = htmlContentString.split('<ul').join('<ul class="bulleted-list"');
      solutionsView = (
        <div className="flexShrink0 solutions" style={{ padding: '24px' }}>
          <div dangerouslySetInnerHTML={{ __html: htmlContentString }} onClick={this.logOnClick} />
          {this.props.solutionBackButton}
        </div>
      );
    }
    const containerClass = this.props.workspaceView
      ? 'win-color-bg-0'
      : 'win-color-bg-0 spacer-md-left spacer-md-right spacer-ms-bottom';

    return (
      <div>
        {(() => {
          if (this.props.activeTopicIncident) {
            return (
              <div className="flexShrink0">
                <div className={containerClass}>
                  <div
                    className="page-title-header"
                    style={{ marginTop: '24px', marginBottom: '8px', paddingLeft: '22px', paddingTop: '20px' }}
                  >
                    <h2 style={{ fontSize: '18px' }}>{CSPServiceHealthStatus_text}</h2>
                  </div>
                  {(() => {
                    return (
                      <table className="table">
                        <thead>
                          <tr>
                            <th
                              className="generalText"
                              style={{
                                color: '#404040',
                                width: '25%',
                                paddingLeft: '22px',
                                fontSize: '14px',
                                fontWeight: 600,
                              }}
                            >
                              {ServicesArea_text}
                            </th>
                            <th
                              className="generalText"
                              style={{
                                color: '#404040',
                                width: '2%',
                                paddingRight: '26px',
                                paddingLeft: '0px',
                                fontSize: '14px',
                                fontWeight: 600,
                              }}
                            >
                              {ServiceAvailability_text}
                            </th>
                            <th
                              className="generalText"
                              style={{
                                color: '#404040',
                                width: '40%',
                                paddingLeft: '0px',
                                fontSize: '14px',
                                fontWeight: 600,
                              }}
                            >
                              {ServicesAnnouncement_text}
                            </th>
                          </tr>
                        </thead>
                        <ServiceHealthStatus service={this.props.activeTopicIncident} level={1} adminRoute={false} />
                      </table>
                    );
                  })()}
                </div>
              </div>
            );
          }
        })()}
        {(() => {
          if (solutionsView) {
            let divClassName = 'flexShrink0';
            return (
              <div className={divClassName}>
                <div className={containerClass}>{solutionsView}</div>
              </div>
            );
          }
        })()}
        {this.props.solutionNextStepDiv}
      </div>
    );
  }
}
